import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { notification } from 'antd';

// services
import * as UniverseService from '../../../../services/bb-api/universe';

export const MemberCounters: React.FC = () => {
	const [membersTotal, setMembersTotal] = useState<number>(0);
	const [members30Days, setMembers30Days] = useState<number>(0);
	const [dateFrom, setDateFrom] = useState(new Date().toISOString())

	useEffect(() => {
		const calculateDates = () => { 
			const currentDate = new Date();
		
			const thirtyDaysAgo = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 30).toISOString();
		
			setDateFrom(thirtyDaysAgo);
		}

		calculateDates();

		const intervalTime = 60 * 1000 // 60 seconds
		const intervalId = setInterval(calculateDates, intervalTime)
		return () => clearInterval(intervalId)
	}, [])

	useEffect(() => {
		try {
			UniverseService.getMemberCount(13).then(setMembersTotal);
			UniverseService.getMemberCount(13, dateFrom).then(setMembers30Days);
		} catch (error) {
			const message = 'Der skete en fejl';
			notification.error({ message });
		}
	}, [dateFrom])


	return (
		<StyledContainer className='members-count'>
			<div className='flex-item'>
				<div className='num-container purple-bg'>
					<p className='label'>Krifa medlemmer på Boblberg</p>
					<h1>{membersTotal.toLocaleString()}</h1>
				</div>
				<div className='num-container'>
					<p className='label'>Tilføjet de sidste 30 dage</p>
					<h1>{members30Days.toLocaleString()}</h1>
				</div>
			</div>
		</StyledContainer>
	);
};

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	/* color: #9ca3af; */
	color: rgba(255, 255, 255, 0.55);

	h1 {
		font-size: 84px;
		font-weight: 700;
		line-height: 1em;
		color: #ffffff;
		margin: 0 0 12px 0;
	}

	p {
		margin: 0;
	}

	.label {
		font-size: 24px;
		line-height: 1em;
		margin: 12px 0 0 0;
	}

	.flex-item {
		display: flex;
	}

	.num-container {
		display: flex;
		flex: 1;
		flex-direction: column;
		background-color: rgba(31, 41, 55, 1);
		height: 180px;
		margin: 1em;
		padding: 12px 48px;
		border-radius: 12px;
		box-shadow: rgba(0,0,0,0.2) 0px 2px 8px 0px;
		justify-content: space-between;
	}

	.purple-bg {
		background-color: #5a1158;
		/* color: rgba(255, 255, 255, 0.7); */
	}
`;
